import { type CollectionSummaryJSONObject, isSystemTag } from '@ikegps/core-api';
import type { IkeCollectionUpgradeFailure } from '@ikegps/core-shared';
import { action, observable, makeObservable } from 'mobx';
import { Services } from '../../services';
import { CurrentState } from '../../state/page.state';
import { AppStore } from '../../store';

export interface FormMigrateFailure {
	failure: IkeCollectionUpgradeFailure;
	collectionId: string;
	collectionTitle: string;
}

export class CollectionFormMigrateModalCtrl {
	collections: CollectionSummaryJSONObject[];
	failures: FormMigrateFailure[] = [];

	@observable updatingForm: boolean = false;

	constructor(collections: CollectionSummaryJSONObject[]) {
		makeObservable(this);

		this.collections = collections;
	}

	async updateFormCollections(targetFormVersion: string) {
		this.setUpdatingForm(true);
		const collectionUuids = this.collections.map((c) => c.uuid);

		await Services.Department.rest.Collection.migrate({
			collections: collectionUuids.map((uuid) => ({ uuid })),
			targetFormVersion,
		});

		await this.refresh(collectionUuids);
		await CurrentState.updateInspectedCollection();
		this.setUpdatingForm(false);
	}

	private async refresh(collectionUuids: string[]) {
		const collectionSummaries = await Promise.all(
			collectionUuids.map((uuid) => AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch())
		);
		return Promise.all([
			AppStore.Tag.refresh(),
			...this.getTagIds(collectionSummaries).map((tagId) => AppStore.TagSummary.getFetchable(tagId).refetch()),
		]);
	}

	private getTagIds(collectionSummaries: CollectionSummaryJSONObject[]): string[] {
		const tags: { [id: string]: boolean } = {};

		for (const collectionSummary of collectionSummaries) {
			for (const tag of collectionSummary.tags) {
				if (!tags[tag] && !isSystemTag(tag)) {
					tags[tag] = true;
				}
			}
		}

		return Object.keys(tags);
	}

	@action private setUpdatingForm(updatingForm: boolean) {
		this.updatingForm = updatingForm;
	}
}
